import React, { Component, Fragment, createRef } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import PretendLink from '@app/components/ui/buttons/PretendLink'
import Modal from '@app/components/ui/modals/Modal'
import Form from './Form'
import SVG from 'react-inlinesvg'
import pencil from '@icons/pencil/blue'

class Row extends Component {
  constructor(props) {
    super(props);

    this.handleEdit = this.handleEdit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.modal = createRef(null)
  }

  handleEdit(e) {
    this.modal.current.open()
  }

  handleSave(e) {
    this.modal.current.close()
  }

  render() {
    const { global: { event }, number, student: { object }, config: { mode } } = this.props

    return (
      <Fragment>
        <div className="h-flex-layout h-flex-layout--row students-table__row">
          <div className="students-table__number">
            {number}.
          </div>
          <div className="w-flex-layout">
            <div className="f--bold f--md students-table__name">
              { object.fullName }
            </div>
            <div className="students-table__content">
              { I18n.t('auth.login') }: { object.login }
            </div>
            <div className="students-table__content">
              { I18n.t('auth.password') }: { object.password }
            </div>
          </div>

          <div className="w-flex-layout w-flex-layout--columns students-table__action">
            {
              mode === "parent" && !event.afterMainTour ? (
                <PretendLink className="btn f--upper" id={object.id}>
                  { I18n.t("registration.completed.parent.solve") }
                </PretendLink>
              ) : null
            }

            <a href="javascript:void(0)"
               className="link link--icon-left f--upper"
               onClick={this.handleEdit}>

               <SVG src={pencil} />
              { I18n.t("js.students_table.edit") }
            </a>
          </div>
        </div>
        <Modal ref={this.modal} className="modal--md">
          <h1 className="modal__title">
            { I18n.t('js.students_table.edit_child') }
          </h1>
          <Form {...this.props} onSave={this.handleSave} />
        </Modal>
      </Fragment>
    )
  }
}

Row.propTypes = {
  global: PropTypes.object.isRequired,
  student: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  updateStudentAction: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired
}

export default Row;
